import ReactModal from 'react-modal';
import styled, { createGlobalStyle } from 'styled-components';
import { space, colors, breakpoints, layering } from 'nicollet-tokens';

const topGap = space.generic.x4; // medium and larger screen only translate offset

const TRANSLATE_Y_OFFSET = '24px';

const setHeight = isShort => {
  if (isShort) {
    return `
      max-height: 60vh;
    `;
  }

  return `
    height: calc(100% - ${topGap});
  `;
};

const StyledReactModal = styled(ReactModal)`
  display: flex;
  flex-direction: column;

  &.ReactModal__Content {
    position: absolute;
    background: ${colors.background.default};
    border-radius: 8px 8px 0 0;
    top: auto;
    left: auto;
    right: auto;
    bottom: 0;
    width: 100%;
    max-width: 475px;
    ${({
  isShort
}) => setHeight(isShort)}
    transform: translateY(100%);
    transition: opacity 300ms, transform 500ms;
    opacity: 0;
    color: ${colors.text.onLight.primary};
    overflow: hidden;
  }
  &.ReactModal__Content--after-open {
    opacity: 1;
    transform: translateY(0);
  }

  @media (min-width: ${breakpoints.sm}) {
    &.ReactModal__Content {
      top: 50%;
      left: 50%;
      bottom: auto;
      border-radius: 8px;
      transform: translateX(-50%) translateY(calc(-50% + ${TRANSLATE_Y_OFFSET}));
      height: auto;
      max-height: 75vh;
    }

    &.ReactModal__Content--after-open {
      transform: translateX(-50%) translateY(-50%);
    }
  }
`;
const PopoverInModalStyles = createGlobalStyle`
.ReactModal__Body--openFixed,
.ReactModal__Body--open {
  ${props => props.scrollbarWidth && props.scrollbarWidth > 0 ? `
    padding-right: ${props.scrollbarWidth}px;
  ` : ''}
  

  [role="tooltip"] {
    z-index: 1070;
  }
} 
`; // react-modal convention

const overlayStyles = {
  overlay: {
    background: layering.overlay.modal,
    zIndex: '1050'
  },
  content: {},
  closeButton: {}
}; // maybe these would make good token values?

const CELL_MODAL_BUTTON_HEIGHT = '76px';
const CELL_MODAL_HEADER_HEIGHT = '64px';
const ContentWrapper = styled.div`
  padding: ${space.generic.x4};
  flex-grow: 1;

  /* height and overflow-y rules permit overflow content in small screens */
  height: calc(100vw - ${CELL_MODAL_HEADER_HEIGHT} - ${CELL_MODAL_BUTTON_HEIGHT});
  overflow-y: auto;

  @media (min-width: ${breakpoints.sm}) {
    height: auto;
  }
`;

export { ContentWrapper, PopoverInModalStyles, StyledReactModal, overlayStyles };
